// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VendorAuthRouteImport } from './routes/vendor-auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VendorsIndexRouteImport } from './routes/vendors/index'
import { Route as SolicitationsIndexRouteImport } from './routes/solicitations/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as PublicIndexRouteImport } from './routes/public/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as AwardsIndexRouteImport } from './routes/awards/index'
import { Route as AuditIndexRouteImport } from './routes/audit/index'
import { Route as VendorsIdRouteImport } from './routes/vendors/$id'
import { Route as VendorBuyerSlugRouteImport } from './routes/vendor/$buyerSlug'
import { Route as SolicitationsNewRouteImport } from './routes/solicitations/new'
import { Route as PublicSlugRouteImport } from './routes/public/$slug'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as EmbedBuyerIdRouteImport } from './routes/embed/$buyerId'
import { Route as DemoTrpcTodoRouteImport } from './routes/demo/trpc-todo'
import { Route as DemoTanstackQueryRouteImport } from './routes/demo/tanstack-query'
import { Route as BuyersResetPasswordRouteImport } from './routes/buyers/reset-password'
import { Route as BuyersRegisterRouteImport } from './routes/buyers/register'
import { Route as BuyersLoginRouteImport } from './routes/buyers/login'
import { Route as BuyersForgotPasswordRouteImport } from './routes/buyers/forgot-password'
import { Route as AwardsIdRouteImport } from './routes/awards/$id'
import { Route as SolicitationsIdIndexRouteImport } from './routes/solicitations/$id/index'
import { Route as SolicitationsBidsBidIdRouteImport } from './routes/solicitations/bids/$bidId'
import { Route as SolicitationsIdEditRouteImport } from './routes/solicitations/$id/edit'
import { Route as PublicVendorsOnboardingRouteImport } from './routes/public/vendors/onboarding'
import { Route as PublicSolicitationsIdRouteImport } from './routes/public/solicitations.$id'
import { Route as DemoStartServerFuncsRouteImport } from './routes/demo/start.server-funcs'
import { Route as DemoStartApiRequestRouteImport } from './routes/demo/start.api-request'
import { Route as VendorBuyerSlugIndexRouteImport } from './routes/vendor/$buyerSlug/index'
import { Route as PublicSlugIndexRouteImport } from './routes/public/$slug/index'
import { Route as PublicSlugEmbedRouteImport } from './routes/public/$slug/embed'
import { Route as DemoStartSsrIndexRouteImport } from './routes/demo/start.ssr.index'
import { Route as DemoStartSsrSpaModeRouteImport } from './routes/demo/start.ssr.spa-mode'
import { Route as DemoStartSsrFullSsrRouteImport } from './routes/demo/start.ssr.full-ssr'
import { Route as DemoStartSsrDataOnlyRouteImport } from './routes/demo/start.ssr.data-only'
import { Route as PublicSolicitationsIdResultsRouteImport } from './routes/public/solicitations.$id.results'
import { Route as PublicSolicitationsIdBidRouteImport } from './routes/public/solicitations.$id.bid'
import { Route as VendorBuyerSlugSolicitationsIndexRouteImport } from './routes/vendor/$buyerSlug/solicitations/index'
import { Route as VendorBuyerSlugOnboardingIndexRouteImport } from './routes/vendor/$buyerSlug/onboarding/index'
import { Route as VendorBuyerSlugContractsIndexRouteImport } from './routes/vendor/$buyerSlug/contracts/index'
import { Route as VendorBuyerSlugBidsIndexRouteImport } from './routes/vendor/$buyerSlug/bids/index'
import { Route as VendorBuyerSlugSolicitationsSolicitationIdRouteImport } from './routes/vendor/$buyerSlug/solicitations/$solicitationId'
import { Route as VendorBuyerSlugOnboardingOrgIdRouteImport } from './routes/vendor/$buyerSlug/onboarding/$orgId'
import { Route as VendorBuyerSlugContractsContractIdRouteImport } from './routes/vendor/$buyerSlug/contracts/$contractId'
import { Route as PublicSlugSolicitationsSolicitationIdRouteImport } from './routes/public/$slug/solicitations/$solicitationId'
import { Route as VendorBuyerSlugBidsBidIdIndexRouteImport } from './routes/vendor/$buyerSlug/bids/$bidId/index'
import { Route as VendorBuyerSlugBidsNewSolicitationIdRouteImport } from './routes/vendor/$buyerSlug/bids/new.$solicitationId'
import { Route as VendorBuyerSlugBidsBidIdEditRouteImport } from './routes/vendor/$buyerSlug/bids/$bidId/edit'

const VendorAuthRoute = VendorAuthRouteImport.update({
            id: '/vendor-auth',path: '/vendor-auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const VendorsIndexRoute = VendorsIndexRouteImport.update({
            id: '/vendors/',path: '/vendors/',getParentRoute: () => rootRouteImport
          })
const SolicitationsIndexRoute = SolicitationsIndexRouteImport.update({
            id: '/solicitations/',path: '/solicitations/',getParentRoute: () => rootRouteImport
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/public/',path: '/public/',getParentRoute: () => rootRouteImport
          })
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
            id: '/organizations/',path: '/organizations/',getParentRoute: () => rootRouteImport
          })
const AwardsIndexRoute = AwardsIndexRouteImport.update({
            id: '/awards/',path: '/awards/',getParentRoute: () => rootRouteImport
          })
const AuditIndexRoute = AuditIndexRouteImport.update({
            id: '/audit/',path: '/audit/',getParentRoute: () => rootRouteImport
          })
const VendorsIdRoute = VendorsIdRouteImport.update({
            id: '/vendors/$id',path: '/vendors/$id',getParentRoute: () => rootRouteImport
          })
const VendorBuyerSlugRoute = VendorBuyerSlugRouteImport.update({
            id: '/vendor/$buyerSlug',path: '/vendor/$buyerSlug',getParentRoute: () => rootRouteImport
          })
const SolicitationsNewRoute = SolicitationsNewRouteImport.update({
            id: '/solicitations/new',path: '/solicitations/new',getParentRoute: () => rootRouteImport
          })
const PublicSlugRoute = PublicSlugRouteImport.update({
            id: '/public/$slug',path: '/public/$slug',getParentRoute: () => rootRouteImport
          })
const InviteTokenRoute = InviteTokenRouteImport.update({
            id: '/invite/$token',path: '/invite/$token',getParentRoute: () => rootRouteImport
          })
const EmbedBuyerIdRoute = EmbedBuyerIdRouteImport.update({
            id: '/embed/$buyerId',path: '/embed/$buyerId',getParentRoute: () => rootRouteImport
          })
const DemoTrpcTodoRoute = DemoTrpcTodoRouteImport.update({
            id: '/demo/trpc-todo',path: '/demo/trpc-todo',getParentRoute: () => rootRouteImport
          })
const DemoTanstackQueryRoute = DemoTanstackQueryRouteImport.update({
            id: '/demo/tanstack-query',path: '/demo/tanstack-query',getParentRoute: () => rootRouteImport
          })
const BuyersResetPasswordRoute = BuyersResetPasswordRouteImport.update({
            id: '/buyers/reset-password',path: '/buyers/reset-password',getParentRoute: () => rootRouteImport
          })
const BuyersRegisterRoute = BuyersRegisterRouteImport.update({
            id: '/buyers/register',path: '/buyers/register',getParentRoute: () => rootRouteImport
          })
const BuyersLoginRoute = BuyersLoginRouteImport.update({
            id: '/buyers/login',path: '/buyers/login',getParentRoute: () => rootRouteImport
          })
const BuyersForgotPasswordRoute = BuyersForgotPasswordRouteImport.update({
            id: '/buyers/forgot-password',path: '/buyers/forgot-password',getParentRoute: () => rootRouteImport
          })
const AwardsIdRoute = AwardsIdRouteImport.update({
            id: '/awards/$id',path: '/awards/$id',getParentRoute: () => rootRouteImport
          })
const SolicitationsIdIndexRoute = SolicitationsIdIndexRouteImport.update({
            id: '/solicitations/$id/',path: '/solicitations/$id/',getParentRoute: () => rootRouteImport
          })
const SolicitationsBidsBidIdRoute = SolicitationsBidsBidIdRouteImport.update({
            id: '/solicitations/bids/$bidId',path: '/solicitations/bids/$bidId',getParentRoute: () => rootRouteImport
          })
const SolicitationsIdEditRoute = SolicitationsIdEditRouteImport.update({
            id: '/solicitations/$id/edit',path: '/solicitations/$id/edit',getParentRoute: () => rootRouteImport
          })
const PublicVendorsOnboardingRoute = PublicVendorsOnboardingRouteImport.update({
            id: '/public/vendors/onboarding',path: '/public/vendors/onboarding',getParentRoute: () => rootRouteImport
          })
const PublicSolicitationsIdRoute = PublicSolicitationsIdRouteImport.update({
            id: '/public/solicitations/$id',path: '/public/solicitations/$id',getParentRoute: () => rootRouteImport
          })
const DemoStartServerFuncsRoute = DemoStartServerFuncsRouteImport.update({
            id: '/demo/start/server-funcs',path: '/demo/start/server-funcs',getParentRoute: () => rootRouteImport
          })
const DemoStartApiRequestRoute = DemoStartApiRequestRouteImport.update({
            id: '/demo/start/api-request',path: '/demo/start/api-request',getParentRoute: () => rootRouteImport
          })
const VendorBuyerSlugIndexRoute = VendorBuyerSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VendorBuyerSlugRoute
          })
const PublicSlugIndexRoute = PublicSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicSlugRoute
          })
const PublicSlugEmbedRoute = PublicSlugEmbedRouteImport.update({
            id: '/embed',path: '/embed',getParentRoute: () => PublicSlugRoute
          })
const DemoStartSsrIndexRoute = DemoStartSsrIndexRouteImport.update({
            id: '/demo/start/ssr/',path: '/demo/start/ssr/',getParentRoute: () => rootRouteImport
          })
const DemoStartSsrSpaModeRoute = DemoStartSsrSpaModeRouteImport.update({
            id: '/demo/start/ssr/spa-mode',path: '/demo/start/ssr/spa-mode',getParentRoute: () => rootRouteImport
          })
const DemoStartSsrFullSsrRoute = DemoStartSsrFullSsrRouteImport.update({
            id: '/demo/start/ssr/full-ssr',path: '/demo/start/ssr/full-ssr',getParentRoute: () => rootRouteImport
          })
const DemoStartSsrDataOnlyRoute = DemoStartSsrDataOnlyRouteImport.update({
            id: '/demo/start/ssr/data-only',path: '/demo/start/ssr/data-only',getParentRoute: () => rootRouteImport
          })
const PublicSolicitationsIdResultsRoute = PublicSolicitationsIdResultsRouteImport.update({
            id: '/results',path: '/results',getParentRoute: () => PublicSolicitationsIdRoute
          })
const PublicSolicitationsIdBidRoute = PublicSolicitationsIdBidRouteImport.update({
            id: '/bid',path: '/bid',getParentRoute: () => PublicSolicitationsIdRoute
          })
const VendorBuyerSlugSolicitationsIndexRoute = VendorBuyerSlugSolicitationsIndexRouteImport.update({
            id: '/solicitations/',path: '/solicitations/',getParentRoute: () => VendorBuyerSlugRoute
          })
const VendorBuyerSlugOnboardingIndexRoute = VendorBuyerSlugOnboardingIndexRouteImport.update({
            id: '/onboarding/',path: '/onboarding/',getParentRoute: () => VendorBuyerSlugRoute
          })
const VendorBuyerSlugContractsIndexRoute = VendorBuyerSlugContractsIndexRouteImport.update({
            id: '/contracts/',path: '/contracts/',getParentRoute: () => VendorBuyerSlugRoute
          })
const VendorBuyerSlugBidsIndexRoute = VendorBuyerSlugBidsIndexRouteImport.update({
            id: '/bids/',path: '/bids/',getParentRoute: () => VendorBuyerSlugRoute
          })
const VendorBuyerSlugSolicitationsSolicitationIdRoute = VendorBuyerSlugSolicitationsSolicitationIdRouteImport.update({
            id: '/solicitations/$solicitationId',path: '/solicitations/$solicitationId',getParentRoute: () => VendorBuyerSlugRoute
          })
const VendorBuyerSlugOnboardingOrgIdRoute = VendorBuyerSlugOnboardingOrgIdRouteImport.update({
            id: '/onboarding/$orgId',path: '/onboarding/$orgId',getParentRoute: () => VendorBuyerSlugRoute
          })
const VendorBuyerSlugContractsContractIdRoute = VendorBuyerSlugContractsContractIdRouteImport.update({
            id: '/contracts/$contractId',path: '/contracts/$contractId',getParentRoute: () => VendorBuyerSlugRoute
          })
const PublicSlugSolicitationsSolicitationIdRoute = PublicSlugSolicitationsSolicitationIdRouteImport.update({
            id: '/solicitations/$solicitationId',path: '/solicitations/$solicitationId',getParentRoute: () => PublicSlugRoute
          })
const VendorBuyerSlugBidsBidIdIndexRoute = VendorBuyerSlugBidsBidIdIndexRouteImport.update({
            id: '/bids/$bidId/',path: '/bids/$bidId/',getParentRoute: () => VendorBuyerSlugRoute
          })
const VendorBuyerSlugBidsNewSolicitationIdRoute = VendorBuyerSlugBidsNewSolicitationIdRouteImport.update({
            id: '/bids/new/$solicitationId',path: '/bids/new/$solicitationId',getParentRoute: () => VendorBuyerSlugRoute
          })
const VendorBuyerSlugBidsBidIdEditRoute = VendorBuyerSlugBidsBidIdEditRouteImport.update({
            id: '/bids/$bidId/edit',path: '/bids/$bidId/edit',getParentRoute: () => VendorBuyerSlugRoute
          })





const PublicSlugRouteChildren = {
  PublicSlugEmbedRoute: PublicSlugEmbedRoute,PublicSlugIndexRoute: PublicSlugIndexRoute,PublicSlugSolicitationsSolicitationIdRoute: PublicSlugSolicitationsSolicitationIdRoute
}

const PublicSlugRouteWithChildren = PublicSlugRoute._addFileChildren(PublicSlugRouteChildren)




const VendorBuyerSlugRouteChildren = {
  VendorBuyerSlugIndexRoute: VendorBuyerSlugIndexRoute,VendorBuyerSlugContractsContractIdRoute: VendorBuyerSlugContractsContractIdRoute,VendorBuyerSlugOnboardingOrgIdRoute: VendorBuyerSlugOnboardingOrgIdRoute,VendorBuyerSlugSolicitationsSolicitationIdRoute: VendorBuyerSlugSolicitationsSolicitationIdRoute,VendorBuyerSlugBidsIndexRoute: VendorBuyerSlugBidsIndexRoute,VendorBuyerSlugContractsIndexRoute: VendorBuyerSlugContractsIndexRoute,VendorBuyerSlugOnboardingIndexRoute: VendorBuyerSlugOnboardingIndexRoute,VendorBuyerSlugSolicitationsIndexRoute: VendorBuyerSlugSolicitationsIndexRoute,VendorBuyerSlugBidsBidIdEditRoute: VendorBuyerSlugBidsBidIdEditRoute,VendorBuyerSlugBidsNewSolicitationIdRoute: VendorBuyerSlugBidsNewSolicitationIdRoute,VendorBuyerSlugBidsBidIdIndexRoute: VendorBuyerSlugBidsBidIdIndexRoute
}

const VendorBuyerSlugRouteWithChildren = VendorBuyerSlugRoute._addFileChildren(VendorBuyerSlugRouteChildren)




const PublicSolicitationsIdRouteChildren = {
  PublicSolicitationsIdBidRoute: PublicSolicitationsIdBidRoute,PublicSolicitationsIdResultsRoute: PublicSolicitationsIdResultsRoute
}

const PublicSolicitationsIdRouteWithChildren = PublicSolicitationsIdRoute._addFileChildren(PublicSolicitationsIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,VendorAuthRoute: VendorAuthRoute,AwardsIdRoute: AwardsIdRoute,BuyersForgotPasswordRoute: BuyersForgotPasswordRoute,BuyersLoginRoute: BuyersLoginRoute,BuyersRegisterRoute: BuyersRegisterRoute,BuyersResetPasswordRoute: BuyersResetPasswordRoute,DemoTanstackQueryRoute: DemoTanstackQueryRoute,DemoTrpcTodoRoute: DemoTrpcTodoRoute,EmbedBuyerIdRoute: EmbedBuyerIdRoute,InviteTokenRoute: InviteTokenRoute,PublicSlugRoute: PublicSlugRouteWithChildren,SolicitationsNewRoute: SolicitationsNewRoute,VendorBuyerSlugRoute: VendorBuyerSlugRouteWithChildren,VendorsIdRoute: VendorsIdRoute,AuditIndexRoute: AuditIndexRoute,AwardsIndexRoute: AwardsIndexRoute,OrganizationsIndexRoute: OrganizationsIndexRoute,PublicIndexRoute: PublicIndexRoute,SettingsIndexRoute: SettingsIndexRoute,SolicitationsIndexRoute: SolicitationsIndexRoute,VendorsIndexRoute: VendorsIndexRoute,DemoStartApiRequestRoute: DemoStartApiRequestRoute,DemoStartServerFuncsRoute: DemoStartServerFuncsRoute,PublicSolicitationsIdRoute: PublicSolicitationsIdRouteWithChildren,PublicVendorsOnboardingRoute: PublicVendorsOnboardingRoute,SolicitationsIdEditRoute: SolicitationsIdEditRoute,SolicitationsBidsBidIdRoute: SolicitationsBidsBidIdRoute,SolicitationsIdIndexRoute: SolicitationsIdIndexRoute,DemoStartSsrDataOnlyRoute: DemoStartSsrDataOnlyRoute,DemoStartSsrFullSsrRoute: DemoStartSsrFullSsrRoute,DemoStartSsrSpaModeRoute: DemoStartSsrSpaModeRoute,DemoStartSsrIndexRoute: DemoStartSsrIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)